import { render, staticRenderFns } from "./AutoClaim.vue?vue&type=template&id=5f07a85a&scoped=true&"
import script from "./AutoClaim.vue?vue&type=script&lang=js&"
export * from "./AutoClaim.vue?vue&type=script&lang=js&"
import style0 from "./AutoClaim.vue?vue&type=style&index=0&id=5f07a85a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f07a85a",
  null
  
)

export default component.exports